var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2H(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#EB3000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4613 24.978V22.382L18.1053 16.486C18.604 16.046 18.956 15.6317 19.1613 15.243C19.3667 14.8543 19.4693 14.4913 19.4693 14.154C19.4693 13.67 19.3703 13.241 19.1723 12.867C18.9743 12.4857 18.6957 12.1887 18.3363 11.976C17.977 11.756 17.5553 11.646 17.0713 11.646C16.5653 11.646 16.118 11.7633 15.7293 11.998C15.348 12.2253 15.051 12.5297 14.8383 12.911C14.6257 13.285 14.5267 13.692 14.5413 14.132H11.4613C11.4613 13.0467 11.6997 12.108 12.1763 11.316C12.653 10.524 13.3167 9.91167 14.1673 9.479C15.018 9.04633 16.008 8.83 17.1373 8.83C18.1713 8.83 19.0953 9.05733 19.9093 9.512C20.7307 9.95933 21.376 10.5863 21.8453 11.393C22.3147 12.1997 22.5493 13.1347 22.5493 14.198C22.5493 14.9827 22.4393 15.6353 22.2193 16.156C21.9993 16.6693 21.673 17.146 21.2403 17.586C20.8077 18.0187 20.276 18.51 19.6453 19.06L15.3553 22.822L15.1133 22.162H22.5493V24.978H11.4613Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 34.0033C14.534 29.7134 8.25 31.392 8.25 35.6074C8.25 40.3449 14.7727 42.0236 16.9601 46.4254L16.9999 46.5L17.0397 46.4254C19.2272 42.0236 25.7498 40.3449 25.7498 35.6074C25.7896 31.392 19.4658 29.7134 16.9999 34.0033Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9998 50.0059C32.5612 42.2841 21.25 45.3057 21.25 52.8932C21.25 61.4208 32.9908 64.4424 36.9282 72.3657L36.9998 72.5L37.0714 72.3657C41.0089 64.4424 52.7497 61.4208 52.7497 52.8932C52.8213 45.3057 41.4384 42.2841 36.9998 50.0059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2H);
export default __webpack_public_path__ + "static/media/2h.a690dd8dc50bb97b89f73bfb4a5ec93f.svg";
export { ForwardRef as ReactComponent };